module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"departingHour":"ساعت خروج","arrivingHour":"ساعت ورود","purchaseTicket":"خرید بلیط","discountedPrice":"قیمت با ‌تخفیف ویژه"}}')
  delete Component.options._Ctor
}
